import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from 'prop-types';
import React from 'react';
import EDIT_MODES from './editModes';
import _ from 'lodash';
import template from './sortByDragList.jsx';
import CustomItemRowObject from './customItemRow.js';
import compose from '../../hoc/compose';
import { dataHooks } from './constants';
var CustomItemRow = CustomItemRowObject._rawClass;
var replaceItems = function replaceItems(list, index1, index2) {
  var newList = list.slice();
  var itemToMove = newList.splice(index1, 1)[0];
  newList.splice(index2, 0, itemToMove);
  return newList;
};
var changeItem = function changeItem(list, newVal, index) {
  var newList = list.slice();
  newList[index] = newVal;
  return newList;
};
var setAttributeToItem = function setAttributeToItem(list, itemIndex, attrName) {
  var newList = _.clone(list);
  var currentItemWithAttr = _.findIndex(list, _defineProperty({}, attrName, true));
  if (currentItemWithAttr === itemIndex) {
    return;
  }
  if (currentItemWithAttr >= 0) {
    newList[currentItemWithAttr] = _.omit(newList[currentItemWithAttr], attrName);
  }
  newList[itemIndex] = _.defaults(_defineProperty({}, attrName, true), newList[itemIndex]);
  return newList;
};
var removeAttributeToItem = function removeAttributeToItem(list, itemIndex, attrName) {
  var newList = _.clone(list);
  newList[itemIndex] = _.omit(newList[itemIndex], attrName);
  return newList;
};
var toObjs = function toObjs(children, spreadAdditionalProps) {
  return _.map(children, function (child) {
    return _objectSpread(_objectSpread({}, spreadAdditionalProps && child.props), {}, {
      id: child.props.id,
      selected: child.props.isSelected,
      label: child.props.label,
      value: child.props.value,
      className: child.props.className,
      automationId: child.props.automationId,
      dataHook: child.props.dataHook,
      customActions: child.props.children,
      content: child.props.content,
      contentBefore: child.props.contentBefore,
      contentAfter: child.props.contentAfter,
      customAction: child.props.customAction,
      disabled: child.props.disabled,
      removable: _.isUndefined(child.props.removable) || Boolean(child.props.removable),
      draggable: _.isUndefined(child.props.draggable) || Boolean(child.props.draggable),
      dragHandleEnabled: child.props.dragHandleEnabled,
      dragHandleTooltipContent: child.props.dragHandleTooltipContent,
      isContextMenuOpen: child.props.isContextMenuOpen,
      onContextMenuToggle: child.props.onContextMenuToggle,
      contextMenuAlignment: child.props.contextMenuAlignment,
      contextMenuDirection: child.props.contextMenuDirection,
      dynamicItemsGetter: child.props.dynamicItemsGetter,
      isDefault: child.props.isDefault,
      skin: child.props.skin,
      isHidden: child.props.isHidden
    });
  });
};
var getValueFromProps = function getValueFromProps(props) {
  return props.value ? props.value : toObjs(props.children, props.spreadAdditionalProps);
};
var toOnChangeMetadata = function toOnChangeMetadata(triggerId, changedItem) {
  return {
    triggerId: triggerId,
    changedItem: changedItem
  };
};
var SortByDragList = /*#__PURE__*/function (_React$Component) {
  function SortByDragList(props) {
    var _this;
    _classCallCheck(this, SortByDragList);
    _this = _callSuper(this, SortByDragList, [props]);
    _this.state = {
      value: getValueFromProps(props),
      draggingItem: null,
      itemInEdit: null,
      editMode: EDIT_MODES.NONE
    };
    _this.optimisticUpdate = function (optimisticValue, updateFunc) {
      _this.setState({
        value: optimisticValue
      }, updateFunc);
    };
    _this.replaceItems = function (index1, index2) {
      var newList = replaceItems(_this.state.value, index1, index2);
      var updateFunc = _this.props.itemMoved ? function () {
        return _this.props.itemMoved(index1, index2);
      } : function () {
        return _this.props.onChange(newList, toOnChangeMetadata('replaceItems', newList[index2]));
      };
      _this.optimisticUpdate(newList, updateFunc);
    };
    _this.changeItem = function (index, newVal) {
      var newList = changeItem(_this.state.value, newVal, index);
      var updateFunc = _this.props.itemChanged ? function () {
        return _this.props.itemChanged(newVal, index);
      } : function () {
        return _this.props.onChange(newList, toOnChangeMetadata('changeItem', newVal));
      };
      return _this.optimisticUpdate(newList, updateFunc);
    };
    _this.isDragging = function (itemIndex) {
      return _this.state.draggingItem === itemIndex;
    };
    _this.setAsDefault = function (itemIndex) {
      return _this.props.onChange(setAttributeToItem(_this.state.value, itemIndex, 'isDefault'), toOnChangeMetadata('setAsDefault'));
    };
    _this.removeAsDefault = function (itemIndex) {
      return _this.props.onChange(removeAttributeToItem(_this.state.value, itemIndex, 'isDefault'), toOnChangeMetadata('removeAsDefault'));
    };
    _this.toggleDefault = function (item, itemIndex) {
      if (_this.props.toggleDefault) {
        return _this.props.toggleDefault(item, itemIndex, _this.state.value);
      }
      return item.isDefault ? _this.removeAsDefault(itemIndex) : _this.setAsDefault(itemIndex);
    };
    _this.selectItem = function (newSelectedIndex) {
      return _this.props.selectItem ? _this.props.selectItem(_this.state.value[newSelectedIndex], newSelectedIndex, _this.state.value) : _this.props.onChange(setAttributeToItem(_this.state.value, newSelectedIndex, 'selected'), toOnChangeMetadata('selectItem'));
    };
    _this.duplicate = function (itemIndex) {
      if (_this.props.duplicateItem) {
        return _this.props.duplicateItem(_this.state.value[itemIndex], itemIndex, _this.state.value);
      }
      if (_.isFunction(_this.props.cloneItem)) {
        var newList = _this.state.value.slice();
        var newNode = _(newList[itemIndex]).omit(['selected', 'isDefault']).thru(_this.props.cloneItem).value();
        newList.splice(itemIndex + 1, 0, newNode);
        _this.props.onChange(newList, toOnChangeMetadata('duplicate'));
      }
    };
    _this["delete"] = function (itemIndex) {
      if (_this.props.deleteItem) {
        return _this.props.deleteItem(_this.state.value[itemIndex], itemIndex, _this.state.value);
      }
      var newList = _this.state.value.slice();
      var deletedItems = newList.splice(itemIndex, 1);
      _this.props.onChange(newList, toOnChangeMetadata('delete', deletedItems[0]));
    };
    _this.getListClasses = function () {
      return _this.props.getClassName('sort-by-drag-list') + (_this.props.disabled ? ' disabled' : '') + (_this.props.noBorderTop ? ' no-border-top' : '');
    };
    _this.hasEditingItem = function () {
      return _this.state.itemInEdit !== null;
    };
    _this.isListDraggable = function (isItemDraggable) {
      if (_.isUndefined(isItemDraggable)) {
        return _this.props.draggable && !_this.hasEditingItem();
      }
      return isItemDraggable;
    };
    _this.getItemEditMode = function (index) {
      return _this.state.itemInEdit === index ? _this.state.editMode : EDIT_MODES.NONE;
    };
    _this.toggleEditLabelMode = function (index) {
      if (_this.state.editMode === EDIT_MODES.EDIT_LABEL) {
        _this.setState({
          itemInEdit: null,
          editMode: EDIT_MODES.NONE
        }, function () {
          if (_.isFunction(_this.props.onLabelEditEnd)) {
            _this.props.onLabelEditEnd(index);
          }
        });
      } else {
        _this.setState({
          itemInEdit: index,
          editMode: EDIT_MODES.EDIT_LABEL
        }, function () {
          if (_.isFunction(_this.props.onLabelEditStart)) {
            _this.props.onLabelEditStart(index);
          }
        });
      }
    };
    _this.toggleEditValueMode = function (index) {
      if (_this.state.editMode === EDIT_MODES.EDIT_VALUE) {
        _this.setState({
          itemInEdit: null,
          editMode: EDIT_MODES.NONE
        }, function () {
          if (_.isFunction(_this.props.onValueEditEnd)) {
            _this.props.onValueEditEnd(index);
          }
        });
      } else {
        _this.setState({
          itemInEdit: index,
          editMode: EDIT_MODES.EDIT_VALUE
        }, function () {
          if (_.isFunction(_this.props.onValueEditStart)) {
            _this.props.onValueEditStart(index);
          }
        });
      }
    };
    _this.getDefaultMenuActions = function (itemIndex) {
      var DEFAULT_MENU_ACTIONS = [{
        key: 'toggleDefault',
        enable: true,
        label: function label(item) {
          return item.isDefault ? this.labelOff : this.labelOn;
        },
        labelOn: 'Set as default',
        labelOff: 'Remove as default',
        dataHook: dataHooks.actionSetDefault,
        action: function action() {
          return _this.toggleDefault(_this.state.value[itemIndex], itemIndex);
        },
        hideIcon: false
      }, {
        key: 'duplicate',
        enable: true,
        label: 'Duplicate',
        dataHook: dataHooks.actionDuplicate,
        action: function action() {
          return _this.duplicate(itemIndex);
        },
        hideIcon: false
      }, {
        key: 'toggleEditLabel',
        enable: true,
        label: 'Rename',
        dataHook: dataHooks.actionRename,
        action: function action() {
          return _this.toggleEditLabelMode(itemIndex);
        },
        hideIcon: false
      }, {
        key: 'toggleEditValue',
        enable: true,
        label: 'Edit value',
        dataHook: dataHooks.actionEditValue,
        action: function action() {
          return _this.toggleEditValueMode(itemIndex);
        },
        hideIcon: false
      }, {
        key: 'delete',
        enable: true,
        label: 'Delete',
        dataHook: dataHooks.actionDelete,
        action: function action() {
          return _this["delete"](itemIndex);
        },
        hideIcon: false
      }];
      return _.reduce(DEFAULT_MENU_ACTIONS, function (result, action, actionIndex) {
        var actionToAdd = _.omit(action, 'key');
        actionToAdd.priority = (actionIndex + 1) * -1;
        result[action.key] = actionToAdd;
        return result;
      }, {});
    };
    _this.getMenuActions = function (itemIndex) {
      var menuActions = _this.getDefaultMenuActions(itemIndex);
      if (_this.props.menuActionsOverrides) {
        _.merge(menuActions, _this.props.menuActionsOverrides);
      }
      return _.pickBy(menuActions, 'enable');
    };
    _this.startDragCallback = function (draggingItemIndex) {
      _this.setState({
        draggingItem: draggingItemIndex
      });
    };
    _this.endDragCallback = function () {
      _this.setState({
        draggingItem: null
      });
    };
    _this.getLabelValidators = function () {
      if (_.isArray(_this.props.labelValidator)) {
        return _this.props.labelValidator;
      }
      return _.isFunction(_this.props.labelValidator) ? [{
        validator: _this.props.labelValidator,
        invalidMessage: _this.props.labelInvalidMessage
      }] : [];
    };
    _this.getValueValidators = function () {
      if (_.isArray(_this.props.valueValidator)) {
        return _this.props.valueValidator;
      }
      return _.isFunction(_this.props.valueValidator) ? [{
        validator: _this.props.valueValidator,
        invalidMessage: _this.props.valueInvalidMessage
      }] : [];
    };
    _this.getStyle = function () {
      return _this.props.paddingBottom ? {
        paddingBottom: _this.props.paddingBottom
      } : {};
    };
    return _this;
  }
  _inherits(SortByDragList, _React$Component);
  return _createClass(SortByDragList, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        value: getValueFromProps(nextProps)
      });
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);
}(React.Component);
SortByDragList.displayName = 'SortByDragList';
SortByDragList.propTypes = {
  /** On change handler. */
  onChange: PropTypes.func,
  /** Callback function when item is hovered. */
  onItemHover: PropTypes.func,
  /** Disables all list interactions */
  disabled: PropTypes.bool,
  /** Disables all list editing */
  disableEditing: PropTypes.bool,
  /** Allows rows to be selectable */
  selectable: PropTypes.bool,
  dynamicHeight: PropTypes.bool,
  dynamicWidth: PropTypes.bool,
  /** Allows rows to be draggable */
  draggable: PropTypes.bool,
  /** Callback on item select. Called with `(item, itemIndex, collection)`. */
  selectItem: PropTypes.func,
  // (item, itemIndex, collection)
  /** Callback on item moved. Called with params `(sourceItemIndex, targetIndex)`. */
  itemMoved: PropTypes.func,
  // optimistic* - (sourceItemIndex, targetIndex)
  /** Callback on item change. Called with params `(item, itemIndex)`. */
  itemChanged: PropTypes.func,
  // optimistic* - (item, itemIndex)
  /** Callback on default toggle. Called with params `(item, itemIndex, collection)`. */
  toggleDefault: PropTypes.func,
  // (item, itemIndex, collection)
  /** Callback function when Duplicate is clicked. You need to implement this if you want it to work. Called with params `(item, itemIndex, collection)`. */
  duplicateItem: PropTypes.func,
  // (item, itemIndex, collection)
  /** Callback function when Delete is clicked. Called with params `(item, itemIndex, collection)`. */
  deleteItem: PropTypes.func,
  // (item, itemIndex, collection)
  /** Label validator. Passes label value as argument. */
  labelValidator: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.shape({
    validator: PropTypes.func.isRequired,
    invalidMessage: PropTypes.string.isRequired
  }))]),
  /** If `labelValidator` passed shows this message on error. */
  labelInvalidMessage: PropTypes.string,
  /** If `labelInvalidMessage` should be translated. */
  shouldTranslateInvalidLabelMessage: PropTypes.bool,
  /** Value validator. Passes value as argument. */
  valueValidator: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.shape({
    validator: PropTypes.func.isRequired,
    invalidMessage: PropTypes.string.isRequired
  }))]),
  /** If `valueValidator` passed shows this message on error. */
  valueInvalidMessage: PropTypes.string,
  /** If `valueInvalidMessage` should be translated. */
  shouldTranslateInvalidValueMessage: PropTypes.bool,
  /** Function which gets the item value and returns the required displayed value. */
  itemValueToDisplay: PropTypes.func,
  /** Function which gets the item label and returns the required displayed label. */
  itemLabelToDisplay: PropTypes.func,
  /** Prefix to show in UI before value. */
  itemValuePrefix: PropTypes.string,
  /** Prefix to show in UI before label. */
  labelValuePrefix: PropTypes.string,
  // NOT USED
  /** Custom placeholder for label input. */
  labelPlaceholder: PropTypes.string,
  /** Custom placeholder for value input. */
  valuePlaceholder: PropTypes.string,
  /** Text for submit button when editing label */
  submitEditLabelButtonText: PropTypes.node,
  /** Text for submit button when editing value */
  submitEditValueButtonText: PropTypes.node,
  /** You can control each action in the context menu individually. Just pass config for any action you want to modify. */
  menuActionsOverrides: PropTypes.shape({
    toggleDefault: PropTypes.shape({
      enable: PropTypes.bool,
      labelOn: PropTypes.string,
      labelOff: PropTypes.string,
      /**
       * Automation ID - for testing purposes, please use dataHook instead
       * @deprecated
       */
      automationId: PropTypes.string,
      dataHook: PropTypes.string,
      priority: PropTypes.number,
      disabled: PropTypes.bool,
      hideIcon: PropTypes.bool
    }),
    duplicate: PropTypes.shape({
      enable: PropTypes.bool,
      label: PropTypes.string,
      /**
       * Automation ID - for testing purposes, please use dataHook instead
       * @deprecated
       */
      automationId: PropTypes.string,
      dataHook: PropTypes.string,
      priority: PropTypes.number,
      disabled: PropTypes.bool,
      hideIcon: PropTypes.bool
    }),
    toggleEditLabel: PropTypes.shape({
      enable: PropTypes.bool,
      label: PropTypes.string,
      labelMaxLength: PropTypes.number,
      /**
       * Automation ID - for testing purposes, please use dataHook instead
       * @deprecated
       */
      automationId: PropTypes.string,
      dataHook: PropTypes.string,
      priority: PropTypes.number,
      disabled: PropTypes.bool,
      hideIcon: PropTypes.bool
    }),
    toggleEditValue: PropTypes.shape({
      enable: PropTypes.bool,
      label: PropTypes.string,
      valueMaxLength: PropTypes.number,
      /**
       * Automation ID - for testing purposes, please use dataHook instead
       * @deprecated
       */
      automationId: PropTypes.string,
      dataHook: PropTypes.string,
      priority: PropTypes.number,
      disabled: PropTypes.bool,
      hideIcon: PropTypes.bool
    }),
    "delete": PropTypes.shape({
      enable: PropTypes.bool,
      label: PropTypes.string,
      /**
       * Automation ID - for testing purposes, please use dataHook instead
       * @deprecated
       */
      automationId: PropTypes.string,
      dataHook: PropTypes.string,
      priority: PropTypes.number,
      disabled: PropTypes.bool,
      hideIcon: PropTypes.bool
    })
  }),
  /** Callback on label edit start. `itemIndex` passed as argument. */
  onLabelEditStart: PropTypes.func,
  // (itemIndex)
  /** Callback on label edit end. `itemIndex` passed as argument. */
  onLabelEditEnd: PropTypes.func,
  // (itemIndex)
  /** Callback on value edit start. `itemIndex` passed as argument. */
  onValueEditStart: PropTypes.func,
  // (itemIndex)
  /** Callback on value edit end. `itemIndex` passed as argument. */
  onValueEditEnd: PropTypes.func,
  // (itemIndex)
  /** Removes top border from list. */
  noBorderTop: PropTypes.bool,
  /** Bottom padding for list container. */
  paddingBottom: PropTypes.number,
  /**  Remove context menu for all items **/
  removeContextMenu: PropTypes.bool,
  /** List item array. Should not be used if you are using `SortByDragListCustomItemRow`. */
  value: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    /**
     * Automation ID - for testing purposes, please use dataHook instead
     * @deprecated
     */
    automationId: PropTypes.string,
    dataHook: PropTypes.string,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    disableEditing: PropTypes.bool,
    isDefault: PropTypes.bool,
    customAction: PropTypes.element,
    skin: PropTypes.oneOf(['standard', 'general'])
  })),
  /** Custom rows using `SortByDragListCustomItemRow`. */
  children: function children(props, propName, componentName) {
    var VALUE_PROP = 'value';
    var children = props[propName];
    if (props[VALUE_PROP] && children) {
      return new Error("Overlapping props '".concat(propName, "' and '").concat(VALUE_PROP, "' supplied to '").concat(componentName, "', expected only one of them."));
    } else if (props[VALUE_PROP]) {
      return null;
    } else if (children) {
      if (!_.isArray(children)) {
        children = [children];
      }
      if (_.some(children, function (child) {
        return _.get(child, 'type._rawClass') !== CustomItemRow;
      })) {
        return new Error("Invalid prop '".concat(propName, "' of type ").concat(typeof child === "undefined" ? "undefined" : _typeof(child), " supplied to '").concat(componentName, "', expected children of type '").concat(CustomItemRow.displayName, "'."));
      }
      return null;
    }
    return new Error("Required props '".concat(propName, "' and '").concat(VALUE_PROP, "' were not specified in '").concat(componentName, "', one of them is required"));
  },
  /** Stops propagation for all items context menu on click to prevent selecting item row */
  stopPropagationOnContextMenuToggle: PropTypes.bool,
  /** Allowing SortByDragListCustomItemRow to keep additional custom props that are passed to the items  */
  spreadAdditionalProps: PropTypes.bool
};
SortByDragList.defaultProps = {
  disabled: false,
  selectable: false,
  dynamicHeight: false,
  dynamicWidth: false,
  draggable: true,
  removeContextMenu: false,
  stopPropagationOnContextMenuToggle: false
};
export default compose(SortByDragList);